import { render, staticRenderFns } from "./ItsContractCustomsInspect.vue?vue&type=template&id=2e056bde&scoped=true&"
import script from "./ItsContractCustomsInspect.vue?vue&type=script&lang=js&"
export * from "./ItsContractCustomsInspect.vue?vue&type=script&lang=js&"
import style0 from "./ItsContractCustomsInspect.vue?vue&type=style&index=0&id=2e056bde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e056bde",
  null
  
)

export default component.exports